export default __webpack_public_path__ + "static/media/env-low.5b974926.png";